<script>
import { ref } from "@vue/composition-api";
import { mapState } from "vuex";
import SiparisDetayModal from "@/components/Modules/Siparisler/SiparisDetayModal.vue";
import { CancelRefundStatuses, getStatusDetail, OrdersStatuses } from "@/core/constants/Orders.constants";
import SiparislerService from "@/services/SiparislerService";

export default {
  name: "CancelAndRefundModal",
  components: { SiparisDetayModal },

  props: {
    value: {
      required: true,
      type: Boolean
    }
  },

  setup() {
    const cancelRefundReq = ref({
      start: 0,
      limit: 15,
      order: "desc"
    });

    const table = {
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Teslim(Gün)", value: "days", sortable: false },
        { text: "Müşteri", value: "userinfo", sortable: false },
        { text: "Talep", value: "type", sortable: false },
        { text: "Durum", value: "status", sortable: false },
        { text: "Not", value: "note", sortable: false },
        { text: "Tarih", value: "date", sortable: false },
        { text: "Sipariş", value: "order", sortable: false },
        { text: "İşlemler", value: "actions", sortable: false }
      ],
      noDataText: "Herhangi bir talep bulunmuyor",
      loadingText: "Talep Listesi Yükleniyor"
    };

    const tableParams = ref({
      page: 1,
      pageCount: 0,
      listStatus: true
    });

    const pagination = ref({
      page: 1,
      lastPage: 0
    });

    const orderDetailModal = ref({
      model: false,
      orderId: null
    });

    const noteDialog = ref({
      model: false,
      data: null
    });

    const updateRequestLoading = ref(false);

    return {
      cancelRefundReq,
      table,
      tableParams,
      pagination,
      orderDetailModal,
      noteDialog,
      updateRequestLoading,
      orderStatuses: OrdersStatuses,
      getStatusDetail
    };
  },

  computed: {
    CancelRefundStatuses() {
      return CancelRefundStatuses
    },
    ...mapState({
      cancelRefundList: state => state.Siparisler.SiparisCancelRefund.cancelRefundList,
      cancelRefundListLoading: state => state.Siparisler.SiparisCancelRefund.cancelRefundListLoading
    })
  },

  methods: {
    cancelAndRefundList() {
      this.$store.dispatch("Siparisler/SiparisCancelRefund/fetchCancelRefundList", this.cancelRefundReq);
    },

    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.cancelRefundReq.start = this.pagination.page * this.cancelRefundReq.limit - this.cancelRefundReq.limit;

        this.cancelAndRefundList();
        // if (!this.yaziAraData.yaziAraText) {
        //   /**
        //    * Ürün listesini getir
        //    */
        //   this.cancelAndRefundList();
        // } else {
        //   /**
        //    * Arama var ise aramaya göre pagination getir
        //    */
        //
        //   /**
        //    * Ürünü aram sonucunu pagination'a göre getir
        //    */
        //   this.yaziAra();
        // }
      }
    },

    showOrderDetail(orderId) {
      this.orderDetailModal.orderId = orderId;
      this.orderDetailModal.model = true;
    },

    showOrderNote(note) {
      this.noteDialog.data = note;
      this.noteDialog.model = true;
    },

    approveRequest(requestId) {
      this.updateRequestLoading = true;
      SiparislerService.approveRequest(requestId).then(({ status, message, data }) => {
        if (status === 200) {
          this.$snotify.success("Talep durumu değiştirildi", this.$t("PANEL.NOTIFY.SUCCESS"));
          this.cancelAndRefundList();
          this.$emit('updateCount', true);
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.updateRequestLoading = false;
      }).catch(() => {
        this.updateRequestLoading = false;
      });
    },

    resqueRequest(requestId) {
      this.updateRequestLoading = true;
      SiparislerService.resqueRequest(requestId).then(({ status, message, data }) => {
        if (status === 200) {
          this.$snotify.success("Talep durumu değiştirildi", this.$t("PANEL.NOTIFY.SUCCESS"));
          this.cancelAndRefundList();
          this.$emit('updateCount', true);
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.updateRequestLoading = false;
      }).catch(() => {
        this.updateRequestLoading = false;
      });
    },

    holdRequest(requestId) {
      this.updateRequestLoading = true;
      SiparislerService.holdRequest(requestId).then(({ status, message, data }) => {
        if (status === 200) {
          this.$snotify.success("Talep durumu değiştirildi", this.$t("PANEL.NOTIFY.SUCCESS"));
          this.cancelAndRefundList();
          this.$emit('updateCount', true);
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.updateRequestLoading = false;
      }).catch(() => {
        this.updateRequestLoading = false;
      });
    }

  },

  created() {
    this.cancelAndRefundList();
  },

  watch: {
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    }
  }
};
</script>

<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1200px">
    <v-card color="white" class="pb-1">
      <v-card-title class="align-center">
        <div>
          İptal & İade Talepleri
        </div>
        <v-spacer />
        <div>
          <v-btn icon @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5 pb-2 px-0">
        <div v-if="cancelRefundListLoading" class="d-flex flex-column align-center py-10">
          <v-progress-circular
            size="100"
            indeterminate
            color="primary"
            class="mb-2"
          ></v-progress-circular>
          <div class="text-body-1 font-weight-medium">
            Talep Listesi Yükleniyor
          </div>
        </div>
        <div v-else>
          <v-data-table
            checkbox-color="pink darken-1"
            :items="cancelRefundList.list"
            :page.sync="tableParams.page"
            :items-per-page="cancelRefundReq.limit"
            :headers="table.headers"
            :no-data-text="table.noDataText"
            calculate-widths
            hide-default-footer
            class="mb-3"
            @page-count="tableParams.pageCount = $event"
            :loading="cancelRefundListLoading"
            :loading-text="table.loadingText"
            :server-items-length="cancelRefundList.count"
          >
            <template v-slot:[`item.id`]="{ item: { id } }">
              <span class="font-weight-medium">{{ id }}</span>
            </template>
            <template v-slot:[`item.days`]="{ item: { orderinfo: { deliverydate } } }">
              <div v-if="deliverydate" class="font-weight-light text-caption text-center">
                {{ $dayjs().diff(deliverydate, "day") }}
              </div>
              <div v-else class="text-center">
                -
              </div>
            </template>
            <template v-slot:[`item.userinfo`]="{ item: { userinfo: { name } } }">
              <span class="grey--text text--darken-3">{{ name }}</span>
            </template>
            <template v-slot:[`item.type`]="{ item: { type } }">
              <v-chip
                small
                :color="getStatusDetail(type).backgroundColor"
                :style="{ color: getStatusDetail(type).textColor }"
              >
                <span v-if="type === orderStatuses.ORDER_REFUND">İade</span>
                <span v-else-if="type === orderStatuses.ORDER_CANCELLED">İptal</span>
              </v-chip>
            </template>
            <template v-slot:[`item.status`]="{ item: { status } }">
              <v-chip v-if="status === CancelRefundStatuses.WAITING_FOR_APPROVAL" small color="amber" class="grey--text text--darken-3">Onay Bekliyor</v-chip>
              <v-chip v-else-if="status === CancelRefundStatuses.CANCELLATION_CONFIRMED" small color="success" class="white--text text--darken-3">Onaylandı
              </v-chip>
              <v-chip v-else-if="status === CancelRefundStatuses.CANCELLATION_CANCELLED" small color="red" class="white--text text--darken-3">Reddedildi</v-chip>
            </template>
            <template v-slot:[`item.note`]="{ item: { note } }">
              <v-btn
                x-small
                rounded
                color="blue"
                elevation="0"
                dark
                class="font-weight-light text-capitalize"
                @click="showOrderNote(note)"
              >
                <v-icon size="1rem" class="mr-1">mdi-eye</v-icon>
                Göster
              </v-btn>
            </template>
            <template v-slot:[`item.date`]="{ item: { date } }">
              <span
                class="grey--text text--darken-3 font-weight-bold text-caption"
              >
                {{ $dayjs(date).format("DD MMMM YYYY HH:mm") }}
              </span>
            </template>
            <template v-slot:[`item.order`]="{ item: { order } }">
              <v-btn small depressed rounded color="grey lighten-2" class="text-capitalize font-weight-light mr-1"
                     @click="showOrderDetail(order)">
                <v-icon size="1rem" color="#333" class="mr-1">mdi-card-multiple</v-icon>
                Sipariş Detayı
              </v-btn>
            </template>
            <template v-slot:[`item.actions`]="{ item: { id, order, status } }">
              <div class="d-flex">
                <v-btn
                  v-if="status === CancelRefundStatuses.WAITING_FOR_APPROVAL"
                  small
                  depressed
                  rounded
                  color="success"
                  class="text-capitalize font-weight-light mr-1"
                  dark
                  @click="approveRequest(id)"
                >
                  <v-icon size="1rem" class="mr-1" dark>mdi-check</v-icon>
                  Onayla
                </v-btn>
                <v-btn
                  v-if="status === CancelRefundStatuses.WAITING_FOR_APPROVAL"
                  small
                  depressed
                  rounded
                  color="red"
                  class="text-capitalize font-weight-light"
                  dark
                  @click="resqueRequest(id)"
                >
                  <v-icon size="1rem" class="mr-1" dark>mdi-minus</v-icon>
                  Reddet
                </v-btn>
                <v-btn
                  v-if="status === CancelRefundStatuses.CANCELLATION_CANCELLED || status === CancelRefundStatuses.CANCELLATION_CONFIRMED"
                  small
                  depressed
                  rounded
                  color="amber"
                  class="text-capitalize font-weight-light"
                  @click="holdRequest(id)"
                >
                  <v-icon size="1rem" color="#333" class="mr-1">mdi-check</v-icon>
                  Beklemeye Al
                </v-btn>
              </div>
            </template>
          </v-data-table>
          <v-pagination v-model="pagination.page" :length="tableParams.pageCount" circle
                        @input="pageClick"></v-pagination>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn small color="red" dark @click="$emit('input', false)">
          <v-icon size="1.25rem" class="mr-1">mdi-close</v-icon>
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
    <siparis-detay-modal v-model="orderDetailModal.model" :order-id="orderDetailModal.orderId" />

    <v-dialog
      v-model="noteDialog.model"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          <div class="text-body-1 font-weight-medium">
            Talep Notu
          </div>
        </v-card-title>

        <v-card-text class="py-5" :class="!noteDialog.data ? 'grey lighten-3' : null">
          <div v-if="noteDialog.data">
            {{ noteDialog.data }}
          </div>
          <div v-else class="text-center">
            Not girilmemiş
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red"
            text
            @click="noteDialog.model = false"
          >
            Kapat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<style scoped>

</style>